import { type AnyObject } from '@Types';
import transformKeyCase from 'Utils/transformKeyCase';
import { useSuspenseStatsigClient } from './useSuspenseStatsigClient';

export function useSuspenseDynamicConfig<T extends AnyObject>(configName: string) {
    const { getDynamicConfig } = useSuspenseStatsigClient();

    const value = getDynamicConfig(configName)?.value || {};

    return transformKeyCase<T>(value, { to: 'camelCase' });
}
